import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["container"];
    static values = {
        uuid: String,
        index: Number,
        type: String,
        propertyType: String,
        property: String
    };

    connect() {
    }

    addTrigger(event) {
        event.preventDefault();
        let index = this.containerTarget.children.length;

        fetch(
            `/user_integrations/${this.uuidValue}/add_trigger?index=${index}&type=${this.typeValue}&property_type=${this.propertyTypeValue}`,
            {
                method: "GET",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
                        .content,
                    Accept: "text/vnd.turbo-stream.html",
                },
            },
        )
            .then((response) => response.text())
            .then((html) => Turbo.renderStreamMessage(html));
    }

    removeTrigger(event) {
        event.preventDefault();
        let index = this.indexValue;

        fetch(
            `/user_integrations/${this.uuidValue}/remove_trigger?index=${index}&type=${this.typeValue}&property_type=${this.propertyTypeValue}`,
            {
                method: "DELETE",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
                        .content,
                    Accept: "text/vnd.turbo-stream.html",
                },
            },
        )
            .then((response) => response.text())
            .then((html) => Turbo.renderStreamMessage(html));
    }
}
